export default __webpack_public_path__ + "static/media/img-gt-mode-on-bg-it_it@2x.69f21527.jpg";